<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 14:14:11
 * @LastEditTime: 2020-09-11 16:24:27
 * @Description: 试题库筛选
 -->
<template>
  <div class="filter-panel">
    <year-filter :years="filterMenu.years" />
    <product-group-filter
      :product-group-codes="filterMenu.groupCodes"
      @set-product-list="setProductListHandler" />
    <product-code-filter :product-list="filterMenu.productList" />
    <library-filter :library-types="filterMenu.libraryTypes"/>
    <filter-action-bar
      @upload-success="questionExcelUploaded"
      @filters-search="filtersSearch"
      @reset-filters="resetFilters"
      @repull-list="repuullList" />
  </div>
</template>

<script>
import YearFilter from './YearFilter.vue';
import ProductGroupFilter from './ProductGroupFilter.vue';
import ProductCodeFilter from './ProductCodeFilter.vue';
import LibraryFilter from './LibraryFilter.vue';
import FilterActionBar from './FilterActionBar.vue';

export default {
  name: 'FilterPanel',
  components: {
    YearFilter,
    ProductGroupFilter,
    ProductCodeFilter,
    LibraryFilter,
    FilterActionBar,
  },
  props: {
    filterMenu: { type: Object, required: true },
  },
  methods: {
    /**
     * 题目表格上传成功
     */
    questionExcelUploaded() {
      this.$emit('upload-success');
    },
    /**
     * 根据筛选条件搜索题库列表
     */
    filtersSearch() {
      this.$emit('filters-search');
    },
    /**
     * 重置筛选条件
     */
    resetFilters(echo) {
      this.$emit('reset-filters', echo);
    },
    /**
     * 多选删除后重新请求列表
     */
    repuullList() {
      this.$emit('repull-list');
    },
    /**
     * 设置型号简称处理函数
     */
    setProductListHandler(productList) {
      this.$emit('set-product-list', productList);
    },
  },
};
</script>

<style lang="less" scoped>
.filter-panel {
  margin-bottom: 16px;
  width: 100%;

  > div {
    margin-bottom: 14px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
